// extracted by mini-css-extract-plugin
module.exports = {"LockEmergencyRelation":"index-module_LockEmergencyRelation_37UHz","emergency":"index-module_emergency_1u-hH"};